export const ReviewApiServiceRewardType = {
  COIN: 'COIN',
  POINT: 'POINT',
} as const

export type TReviewApiServiceRewardType =
  (typeof ReviewApiServiceRewardType)[keyof typeof ReviewApiServiceRewardType]

export const ReviewApiServiceCategory = {
  DOMESTIC_ACCOMMODATION: 'DOMESTIC_ACCOMMODATION',
  DOMESTIC_LEISURE: 'DOMESTIC_LEISURE',
} as const

export type TReviewApiServiceCategory =
  (typeof ReviewApiServiceCategory)[keyof typeof ReviewApiServiceCategory]

export interface IReviewApiServiceExpectedReward {
  type: TReviewApiServiceRewardType
  /**
   * 적립예정 금액
   */
  amount: number
  /**
   * 적립율
   */
  rate: number
}

export interface IReviewApiServiceCheckAvailabilityParams {
  memberNo: number
  orders: {
    serviceCategory: TReviewApiServiceCategory
    orderId: string
    amount?: number
  }[]
}

interface IReviewApiServiceCheckAvailabilityCommon {
  serviceCategory: TReviewApiServiceCategory
  orderId: string
}

export const ReviewApiServiceUnavailableReason = {
  // 후기 작성 완료
  ALREADY_WRITTEN: 'ALREADY_WRITTEN',
  // 작성 기한 경과
  ELAPSED: 'ELAPSED',
  // 이용완료 아님
  NOT_USED: 'NOT_USED',
  // 주문완료 상태 아님 (취소 등)
  NOT_ORDERED: 'NOT_ORDERED',
  // 조회 불가 주문 (미입수 데이터)
  NOT_FOUND: 'NOT_FOUND',
} as const

export type TReviewApiServiceUnavailableReason =
  (typeof ReviewApiServiceUnavailableReason)[keyof typeof ReviewApiServiceUnavailableReason]

/**
 * 후기 작성 가능
 */
interface IReviewApiServiceCheckAvailabilityAvailable
  extends IReviewApiServiceCheckAvailabilityCommon {
  available: true
  reviewAvailableUntil: string
  unavailableReason: null
  expectedReward: IReviewApiServiceExpectedReward
}

/**
 * 후기 작성 불가능
 */
interface IReviewApiServiceCheckAvailabilityUnavailable
  extends IReviewApiServiceCheckAvailabilityCommon {
  available: false
  reviewAvailableUntil: null
  unavailableReason: TReviewApiServiceUnavailableReason
  expectedReward: null
}

export type TReviewApiServiceCheckAvailability = (
  | IReviewApiServiceCheckAvailabilityAvailable
  | IReviewApiServiceCheckAvailabilityUnavailable
)[]
